import React, { useEffect, useState } from "react";
import useSave from "../Hooks/useSave";
import Login from "./login/Login";

export default function ProtectRoutes({ view, children }) {
  const { fetchGraphql } = useSave();
  const [permissions, setPermissions] = useState(["viewCreatePassword"]);
  // console.log(permissions);

  useEffect(() => {
    if (localStorage.getItem("token")) {
      fetchGraphql({
        query: `query Query {
        userPermissions
      }`,
      }).then((result) => setPermissions(result.data.userPermissions));
    }
  }, []);

  const hasPermission = permissions.includes(view);

  if (hasPermission) {
    return children;
  } else {
    return <Login />;
  }
}
